import * as _ from 'lodash';
import { AdAnalyticsReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

export const initialState: AdAnalyticsReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
};

const adAnalyticsReducer = createReducer(initialState, {
  GET_AD_ANALYTICS_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = _.get(action, 'payload.data');
  },
  GET_AD_ANALYTICS_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },
  GET_AD_ANALYTICS_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: _.get(action, 'payload.response.data.error'),
      done: false,
    };
  },
});

export default adAnalyticsReducer;
